/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

//import axios from '@/axios.js';
import firebase from '@/services/saleData';
import 'firebase/database';
import 'firebase/firestore';
//import router from '@/router';
import moment from "moment-timezone";
import _ from 'lodash';
import axios from 'axios';
export default {
  // addItem({ commit }, item) {
  //   return new Promise((resolve, reject) => {
  //     axios.post("/api/data-list/products/", {item: item})
  //       .then((response) => {
  //         commit('ADD_ITEM', Object.assign(item, {id: response.data.id}))
  //         resolve(response)
  //       })
  //       .catch((error) => { reject(error) })
  //   })
  // },
  
  /*saveData ({state}) {
    const user = _.clone(state.user)
    const emailKey = user.email.toString().replace(/\./g, '||')
    if(user.edit && user.password === '') {
      delete user.password
    }
    if(user.company === undefined) {
      user.company = '--TEST--'
    }
    return new Promise(async (resolve, reject) => {
      if(user.avatar_path.substring(0,5) === 'https'){
        user.avatar_path = null
        user.edit = null
        firebase.database().ref(`/users/${emailKey}`).set(user).then(()=> {
          resolve(`${user.firstname} ${user.lastname}`)
        }).catch((error) => { reject(error) })
        
      }else{
        user.avatar_path = null
        await firebase.storage().ref().child(`users/${user.email}`).put(user.avatar).then(() => {
          user.avatar = `https://firebasestorage.googleapis.com/v0/b/oktallentdb.appspot.com/o/users%2F${user.email}?alt=media`;
        });
        firebase.database().ref(`/users/${emailKey}`).set(user).then(()=> {
          resolve(`${user.firstname} ${user.lastname}`)
        }).catch((error) => { reject(error) })
      }
    })
  },*/
  async updateStatusBack({rootState,state}){
    const statementUser = state.selected;
    firebase.firestore().collection("krungsri").doc(statementUser.key).get().then((result)=>{
      if(result.data().status === rootState.AppActiveUser.email){
        firebase.firestore().collection("krungsri").doc(statementUser.key).update({
          status:'กำลังดำเนินการ'
        });
      }
    });
  },
  async updateStatus2({state,rootState,commit},status){
    const data = state.selected;
    if(data.key){
      firebase.firestore().collection("krungsri").doc(data.key).update({
        status,
        updatetime:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
        employee:rootState.AppActiveUser,
      });
    }
    commit('SET_POPUP3',false);
  },
  async updateStatus({rootState},data){
    firebase.firestore().collection("krungsri").doc(data.key).update({
      status:rootState.AppActiveUser.email,
      updatetime:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
      employee:rootState.AppActiveUser,
    });
  },
  async addStateMent({ rootState },{userId,qty,bonus,datetime}){
    //check promotion
    return new Promise(async (resolve) => {
      const user = (await firebase.database().ref(`/users/${userId.key}`).once('value')).val();
      let bank = '';
      let id = '';
      const date_time = datetime.split(' ');
      const date = date_time[0].split('-');
      if(user.bank!== 'truewallet'){
        switch(user.bank) {
          case 'bankokbank':
            bank = '(BBL)';
            break;
          case 'kbank':
            bank = '(KBANK)';
            break;
          case 'ttb':
            bank = '(TTB)';
            break;
          case 'ktb':
            bank = '(KTB)';
            break;
          case 'krungsri':
            bank = '(BAY)';
            break;
          case 'gsb':
            bank = '(GSB)';
            break;  
          case 'cimb':
            bank = '(CIMB)';
            break;  
          case 'uob':
            bank = '(UOB)';
            break;  
          case 'kiatnakin':
            bank = '(KK)';
            break;    
          case 'ghbank':
            bank = '(BAAC)';
            break;
          case 'scb':
            bank = 'SCB';
            break;  
          default:
            bank = '';
            break;
            // code block
        }
        const _bank = (bank==='SCB')?user.account_no_check_scb2:user.account_no_check_scb
        id = `${moment().tz("Asia/Bangkok").format("YYYY-MM-DD")}-${date_time[1]}-${bank}-${_bank}-${Number(qty).toFixed(2)}`;
      }else{
        id = `${moment().tz("Asia/Bangkok").format("YYYY-MM-DDTHH:mm:ss")}-+0700-${user.account_no}-${Number(qty)}00`;
      }
      await axios({
        method: "post",
        url: "https://api.xxmac.co/addcreditadmin",
        data: {
          key: userId.key,
          credit:qty,
          bonus:(user.bonus && !bonus)?user.bonus:'N',
          insertdone:false,
          email:rootState.AppActiveUser.firstname,
          code:user.code,
        }
      }).then(async response => {
        if (response.data && response.data.status) {
          console.log(id);
          await firebase.firestore().collection("krungsri").doc(id).set({
            status:'ดำเนินการแล้ว',
            type:'ฝาก',
            qty:(!bonus)?qty:0,
            bonus:(bonus)?qty:(response.data.bonus)?response.data.bonus:0,
            createdate:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
            updatetime:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
            date:date[2]+'-'+date[1]+'-'+date[0]+' '+date_time[1]+':00',
            employee:rootState.AppActiveUser,
            code:user.code,
            userkey:userId.key,
            user,
            accountno:user.account_no,
            bank:user.bank,
            bonustoday: (response.data.bonustoday)?response.data.bonustoday:firebase.firestore.FieldValue.delete(),
            turncredit: (response.data.bonustoday && response.data.bonustoday.turncredit)?response.data.bonustoday.turncredit:0,
            canwithdraw: (response.data.bonustoday && response.data.bonustoday.canwithdraw)?response.data.bonustoday.canwithdraw:0,
            employeeCreated:true,
          }).then(async ()=>{
            await firebase.firestore().collection("history").add({
              krungsriId:id,
              code:user.code,
              userkey:userId.key,
              qty:(!bonus)?qty:0,
              bonus:(bonus)?qty:(response.data.bonus)?response.data.bonus:0,
              status:'ดำเนินการแล้ว',
              type:'ฝาก',
              updatetime:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
              createdate:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
              date:date[2]+'-'+date[1]+'-'+date[0]+' '+date_time[1]+':00',
              employee:rootState.AppActiveUser,
              bonustoday: (response.data.bonustoday)?response.data.bonustoday:firebase.firestore.FieldValue.delete(),
              turncredit: (response.data.bonustoday && response.data.bonustoday.turncredit)?response.data.bonustoday.turncredit:0,
              canwithdraw: (response.data.bonustoday && response.data.bonustoday.canwithdraw)?response.data.bonustoday.canwithdraw:0,
              employeeCreated:true,
            });
          });
          resolve(response.data);
        }else if(response.data.error){
          alert(response.data.error);
          resolve(response.data);
        }
      });
    })
   
  },
  async updateStatement({ commit,rootState },{selected}){
    //check promotion
    await firebase.firestore().collection("krungsri").doc(selected.key).update({
      status:rootState.AppActiveUser.email,
      updatetime:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
      employee:rootState.AppActiveUser,
    });
    const user = (await firebase.database().ref(`/users/${selected.userkey}`).once('value')).val();
    if(user.level1)
    delete user.level1;
    if(user.level2)
    delete user.level2;
    if(user.web)
    delete user.web;
    await axios({
      method: "post",
      //url: "https://api.xxmac.co/addcredit2",
      url: "https://api.xxmac.co/addcredit2",
      data: {
        userkey: selected.userkey,
        credit:selected.qty,
        bonus:(user.bonus)?user.bonus:'N',
        insertdone:true,
        key:selected.key,
        employee:rootState.AppActiveUser,
        user:user,
        detail:selected.firstname
      }
    }).then(async response => {
      console.log(response.data);
      // if (response.data && response.data.status) {
      //   await firebase.firestore().collection("krungsri").doc(selected.key).update({
      //     status:'ดำเนินการแล้ว',
      //     type:'ฝาก',
      //     updatetime:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
      //     employee:rootState.AppActiveUser,
      //     code:user.code,
      //     userkey:selected.userkey,
      //     user,
      //     qty:selected.qty,
      //     accountno:user.account_no,
      //     bank:user.bank,
      //     bonustoday: (response.data.bonustoday)?response.data.bonustoday:'',
      //     bonus: (response.data.bonus)?response.data.bonus:0,
      //     turncredit: (response.data.bonustoday && response.data.bonustoday.turncredit)?response.data.bonustoday.turncredit:0,
      //     canwithdraw: (response.data.bonustoday && response.data.bonustoday.canwithdraw)?response.data.bonustoday.canwithdraw:0,
      //   });
      //   await firebase.firestore().collection("history").doc(selected.key).set({
      //       krungsriId:selected.key,
      //       code:user.code,
      //       userkey:selected.userkey,
      //       qty:selected.qty,
      //       status:'ดำเนินการแล้ว',
      //       type:'ฝาก',
      //       updatetime:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
      //       createdate:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
      //       employee:rootState.AppActiveUser,
      //       bonustoday: (response.data.bonustoday)?response.data.bonustoday:firebase.firestore.FieldValue.delete(),
      //       bonus: (response.data.bonus)?response.data.bonus:0,
      //       turncredit: (response.data.bonustoday && response.data.bonustoday.turncredit)?response.data.bonustoday.turncredit:0,
      //       canwithdraw: (response.data.bonustoday && response.data.bonustoday.canwithdraw)?response.data.bonustoday.canwithdraw:0,
      //   });
      // }else if(response.data.error){
      //   await firebase.firestore().collection("krungsri").doc(selected.key).update({
      //     status:response.data.error,
      //   });
      // }
    });
    // const users = state.users;
    // const statementUser = state.statementUser;
    // let credit = Math.floor(statementUser.qty.toString().replace(',',''));
    // if(bonus){
    //   let b = Math.floor(bonus.toString().replace(',',''));
    //   credit = Number(credit)+Number(b);
    // }
    // await firebase.firestore().collection("history").doc(users[selected].key).update({
    //   status:'loading...',
    //   updatetime:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
    //   employee:rootState.AppActiveUser,
    //   bonus,
    // });
    // await firebase.firestore().collection("krungsri").doc(statementUser.key).update({
    //   status:'loading...',
    //   updatetime:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
    //   employee:rootState.AppActiveUser,
    //   bonus,
    //   userId:users[selected].userId
    // });
    // axios({
    //   method: "post",
    //   url: "https://api.ufaeasy888.com/addcredit",
    //   data: {
    //     userId: users[selected].userId,
    //     credit
    //   }
    // }).then(async response => {
    //   if (response.data && response.data.status) {
    //     firebase.firestore().collection("history").doc(users[selected].key).update({
    //       status:'ดำเนินการแล้ว',
    //     });
    //     firebase.firestore().collection("krungsri").doc(statementUser.key).update({
    //       status:'ดำเนินการแล้ว',
    //     });
    //   }else{
    //     firebase.firestore().collection("history").doc(users[selected].key).update({
    //       status:'กำลังดำเนินการ',
    //       updatetime:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
    //       employee:rootState.AppActiveUser,
    //     });
    //     firebase.firestore().collection("krungsri").doc(statementUser.key).update({
    //       status:'ไม่สามารถเพิ่ม credit ได้',
    //       updatetime:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
    //       employee:rootState.AppActiveUser,
    //     });
    //   }
    // })
    // .catch(function() {
    //   firebase.firestore().collection("history").doc(users[selected].key).update({
    //     status:'กำลังดำเนินการ',
    //     updatetime:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
    //     employee:rootState.AppActiveUser,
    //   });
    //   firebase.firestore().collection("krungsri").doc(statementUser.key).update({
    //     status:'ไม่สามารถเพิ่ม credit ได้',
    //     updatetime:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
    //     employee:rootState.AppActiveUser,
    //   });
    // });
    commit('SET_POPUP',false);
  },
  async fetchUsers({ commit },statement) {
    const _users = (await firebase.database().ref(`/users`).once('value')).val();
    const users = [];
    for(const x in _users){
      users[_users[x].userId] = _users[x];
    }
    commit('SET_STATEMENT_USER',statement);
    if(statement.userId){
      firebase.firestore().collection("history").where("type", "==", "ฝาก").where('userId','==',statement.userId).where('status','==','กำลังดำเนินการ').orderBy('createdate','desc').get().then((query)=>{
        const statements = [];
        query.forEach((doc) => {
          const data = doc.data();
          data.key = doc.id;
            if(users[data.userId]){
              const user = users[data.userId];
              data.linename = user.linename;
              data.firstname = user.firstname;
              data.lastname = user.lastname;
              data.bank = user.bank;
              data.account_no = user.account_no;
              data.code = user.code;
              data.pictureUrl = user.pictureUrl;
            }
          statements.push(data);
        });
        commit('SET_USERS', statements);
      });
    }else{
      firebase.firestore().collection("history").where("type", "==", "ฝาก").where('status','==','กำลังดำเนินการ').orderBy('createdate','desc').get().then((query)=>{
          const statements = [];
          query.forEach((doc) => {
            const data = doc.data();
            data.key = doc.id;
            if(users[data.userId]){
              const user = users[data.userId];
              data.linename = user.linename;
              data.firstname = user.firstname;
              data.lastname = user.lastname;
              data.bank = user.bank;
              data.account_no = user.account_no;
              data.code = user.code;
              data.pictureUrl = user.pictureUrl;
            }
            statements.push(data);
          });
          commit('SET_USERS', statements);
      });
    }
    
  },
  async fetchStatement ({ commit,state }) {
    const _users = (await firebase.database().ref(`/users`).once('value')).val();
    const users = [];
    for(const x in _users){
      users[_users[x].userId] = _users[x];
      users[_users[x].userId].key = x;
    }
    let statements = (state.statement.length>0)?state.statement:[];
    firebase.firestore().collection("krungsri").where("type", "==", "ฝาก").orderBy('date','desc')
    .onSnapshot((snapshot) => {
        snapshot.docChanges().forEach((change) => {
          if (change.type === "added") {
            const statement = change.doc.data();
            if(users[statement.userId]){
              const user = users[statement.userId];
              statement.key = change.doc.id;
              statement.user_id = user.key;
              statement.linename = user.linename;
              statement.firstname = user.firstname;
              statement.lastname = user.lastname;
              statement.bank = user.bank;
              statement.account_no = user.account_no;
              statement.code = user.code;
              statement.pictureUrl = user.pictureUrl;
              statement.createdate = statement.date;
              statements.push(statement);
            }else{
              statement.key = change.doc.id;
              statement.user_id = '';
              statement.linename = '';
              statement.firstname = '';
              statement.lastname = '';
              statement.account_no = statement.bank;
              statement.bank = '';
              statement.code = '';
              statement.pictureUrl = '';
              statement.createdate = statement.date;
              statements.push(statement);
            }
          }
          if (change.type === "modified") {
              const value = change.doc.data();
              const keyUser = _.findKey(statements, function(o) { return o.key === change.doc.id; });
              if(keyUser){
                const statement =  statements[keyUser];
                statement.qty = value.qty;
                statement.status = value.status;
                statement.updatetime = moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss");
                statement.createdate = value.date;
                statements.splice(keyUser, 1);
                statement.key = change.doc.id;
                statements.splice(keyUser, 0, statement);
              }
          }
        });
        console.log(statements);
        if(statements.length > 0){
          statements = _.orderBy(statements, ['createdate'],['desc']);
          commit('SET_STATEMENT', statements);
        }
    });
    //commit('SET_USERS', []);
  },
  removeRecord({state}, key){
    for(const x in state.statement){
      if(state.statement[x].key === key){
        state.statement.splice(x, 1);
        break;
      }
    }
  },
  async updateFieldStatement({rootState},{key,value,column}) {
    if(key){
      firebase.firestore().collection("krungsri").doc(key).update({
          [`${column}`]:Number(value),
          employee:rootState.AppActiveUser,
      });
    }
  },
  /*updateUsers({state,commit}, {key,value}){
    console.log(key);
    console.log(value);
    console.log(state.users);
    const users = state.users;
    const keyUser = _.findKey(users, function(o) { return o.key === key; });
    if(keyUser){
      users.splice(keyUser, 1);
      value.key = key;
      users.splice(keyUser, 0, value);
      commit('SET_USERS', users);
    }
  },*/
}
